(() => {
  'use strict';
  const streamRoot = 'https://m.media-amazon.com/images/S/vse-vms-transcoding-artifact-us-east-1-prod/';
  const streams = {
    '017b185ce7fa443e90de404184aa8505': '61b15026-430b-4cf3-82d8-59290209c642/default.jobtemplate.hls.m3u8',
    '0ac2110862e748dd93bd9d5b1b106431': '2569c721-eeb0-44a7-8e89-66343a8ac47f/default.jobtemplate.hls.m3u8',
    '074ac3a102aa483db4911597e67f5167': '434a50f3-3154-4df1-9d36-63d8c524dbaa/default.vertical.jobtemplate.hls.m3u8',
    '0d8df714ec0949e4be5d46db1f9669b3': 'e9bcdd04-bce5-4aec-b452-4537366f8bc9/default.jobtemplate.hls.m3u8',
    '0669e59bea2c434ab1e887676d31874d': '1ab7b3f4-8d6e-4e24-8536-1f76c0875edf/default.jobtemplate.hls.m3u8'
  };
  let hlsPromise;
  const loadHls = () => {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsPromise) hlsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js';
      script.async = true;
      script.onload = () => window.Hls ? resolve(window.Hls) : reject(new Error('Player unavailable'));
      script.onerror = () => { script.remove(); hlsPromise = null; reject(new Error('Player unavailable')); };
      document.head.append(script);
    });
    return hlsPromise;
  };
  // Prefer MediaSource playback when supported; some browsers advertise native
  // HLS support but stall before loading the playlist. Safari can fall back to native HLS.
  const supportedHls = async () => {
    try { const Hls = await loadHls(); return Hls.isSupported() ? Hls : null; }
    catch (_) { return null; }
  };
  const initVideos = (widget) => {
    if (widget.dataset.videoReady) return;
    widget.dataset.videoReady = 'true';
    const cards = [...widget.querySelectorAll('[data-review-video-card]')];
    const modal = widget.querySelector('dialog');
    const player = modal.querySelector('video');
    const status = modal.querySelector('[data-video-status]');
    const motion = widget.querySelector('[data-video-motion]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 767px)');
    const connection = navigator.connection;
    const pauseByDefault = () => reduced.matches || mobile.matches || Boolean(connection?.saveData) || ['slow-2g', '2g'].includes(connection?.effectiveType);
    let paused = pauseByDefault();
    let cartOpen = Boolean(document.querySelector('[data-cart-drawer].is-open'));
    let disposed = false;
    let fullHls = null;
    let request = 0;
    let trigger = null;
    let scrollStyle = '';
    document.body.append(modal);
    motion.hidden = false;
    const previews = cards.map((card) => ({ card, video: card.querySelector('video'), visible: false, hls: null, ready: false, loading: false, failed: false }));
    const allowed = (item) => !disposed && !paused && !cartOpen && !document.hidden && !modal.open && item.visible && !item.failed;
    const startPreview = async (item) => {
      if (!allowed(item) || item.loading) return;
      item.video.muted = true;
      if (item.ready) {
        item.hls?.startLoad();
        item.video.play().catch(() => {});
        return;
      }
      item.loading = true;
      const source = streamRoot + streams[item.card.dataset.videoId];
      try {
        const Hls = await supportedHls();
        if (disposed) return;
        if (Hls) {
          item.hls = new Hls({ startLevel: 0, capLevelToPlayerSize: true, maxBufferLength: 8, maxMaxBufferLength: 12, backBufferLength: 0 });
          item.hls.on(Hls.Events.ERROR, (_, data) => {
            if (data.fatal) { item.failed = true; item.hls?.destroy(); item.hls = null; }
          });
          item.hls.loadSource(source);
          item.hls.attachMedia(item.video);
        } else if (item.video.canPlayType('application/vnd.apple.mpegurl')) item.video.src = source;
        else throw new Error('Preview unavailable');
        item.ready = true;
        if (allowed(item)) item.video.play().catch(() => {});
        else item.hls?.stopLoad();
      } catch (_) {
        item.failed = true;
      } finally { item.loading = false; }
    };
    const syncPreviews = () => {
      motion.textContent = paused ? motion.dataset.resumeLabel : motion.dataset.pauseLabel;
      motion.setAttribute('aria-pressed', String(paused));
      previews.forEach((item) => {
        if (allowed(item)) startPreview(item);
        else { item.video.pause(); item.hls?.stopLoad(); }
      });
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { const item = previews.find((p) => p.card === entry.target); if (item) item.visible = entry.isIntersecting && entry.intersectionRatio >= .45; });
      syncPreviews();
    }, { threshold: [0, .45] });
    previews.forEach((item) => {
      observer.observe(item.card);
      item.video.addEventListener('loadedmetadata', () => {
        if (Number.isFinite(item.video.duration) && item.video.duration > 10) item.video.currentTime = 4;
      });
      item.video.addEventListener('timeupdate', () => {
        if (item.video.currentTime >= 10 && item.video.duration > 10) item.video.currentTime = 4;
      });
      item.video.addEventListener('error', () => { item.failed = true; });
    });
    motion.addEventListener('click', () => { paused = !paused; syncPreviews(); });
    const onPreference = () => { paused = pauseByDefault(); syncPreviews(); };
    const onCartVisibility = (event) => { cartOpen = event.detail.open; syncPreviews(); };
    reduced.addEventListener('change', onPreference);
    mobile.addEventListener('change', onPreference);
    document.addEventListener('schroder:cart-visibility', onCartVisibility);
    document.addEventListener('visibilitychange', syncPreviews);
    const clearPlayer = () => {
      request++;
      player.pause();
      fullHls?.destroy();
      fullHls = null;
      player.removeAttribute('src');
      player.load();
    };
    modal.addEventListener('close', () => {
      clearPlayer();
      document.body.style.overflow = scrollStyle;
      syncPreviews();
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
    modal.querySelector('[data-video-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', (event) => {
      if (event.target !== modal) return;
      const bounds = modal.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) modal.close();
    });
    player.addEventListener('playing', () => { status.textContent = ''; });
    player.addEventListener('error', () => { if (modal.open && player.getAttribute('src')) status.textContent = widget.dataset.errorLabel; });
    cards.forEach((card) => card.addEventListener('click', async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof modal.showModal !== 'function') return;
      event.preventDefault();
      clearPlayer();
      const activeRequest = request;
      trigger = card;
      modal.querySelector('[data-video-title]').textContent = card.dataset.videoTitle;
      modal.querySelector('[data-video-original]').href = card.href;
      player.poster = card.querySelector('video').poster;
      status.textContent = widget.dataset.loadingLabel;
      scrollStyle = document.body.style.overflow;
      modal.showModal();
      document.body.style.overflow = 'hidden';
      syncPreviews();
      try {
        const source = streamRoot + streams[card.dataset.videoId];
        const Hls = await supportedHls();
        if (disposed || activeRequest !== request || !modal.open) return;
        if (Hls) {
          fullHls = new Hls({ capLevelToPlayerSize: true, maxBufferLength: 30 });
          fullHls.on(Hls.Events.MANIFEST_PARSED, () => { if (activeRequest === request && modal.open) player.play().catch(() => { status.textContent = ''; }); });
          fullHls.on(Hls.Events.ERROR, (_, data) => { if (data.fatal && activeRequest === request) status.textContent = widget.dataset.errorLabel; });
          fullHls.loadSource(source);
          fullHls.attachMedia(player);
        } else if (player.canPlayType('application/vnd.apple.mpegurl')) {
          player.src = source;
          player.play().catch(() => { status.textContent = widget.dataset.errorLabel; });
        } else throw new Error('Playback unavailable');
      } catch (_) { if (activeRequest === request) status.textContent = widget.dataset.errorLabel; }
    }));
    syncPreviews();
    widget.disposeVideos = () => {
      disposed = true;
      observer.disconnect();
      reduced.removeEventListener('change', onPreference);
      mobile.removeEventListener('change', onPreference);
      document.removeEventListener('schroder:cart-visibility', onCartVisibility);
      document.removeEventListener('visibilitychange', syncPreviews);
      previews.forEach((item) => { item.video.pause(); item.hls?.destroy(); item.video.removeAttribute('src'); item.video.load(); });
      if (modal.open) modal.close();
      clearPlayer();
      modal.remove();
    };
  };
  const initSticky = (section) => {
    const sticky = section.querySelector('[data-sticky-purchase]');
    const form = section.querySelector('.js-product-form');
    const mainButton = form?.querySelector('[data-add-to-cart]');
    if (!sticky || !mainButton || sticky.dataset.ready) return;
    sticky.dataset.ready = 'true';
    const button = sticky.querySelector('button');
    const price = section.querySelector('[data-product-price]');
    const mobile = matchMedia('(max-width: 989px)');
    let scheduled = false;
    const update = () => {
      scheduled = false;
      sticky.hidden = !mobile.matches || mainButton.getBoundingClientRect().bottom > 0;
      document.body.classList.toggle('has-sticky-purchase', !sticky.hidden);
      button.disabled = mainButton.disabled;
      button.textContent = mainButton.querySelector('[data-add-label]')?.textContent || mainButton.textContent.trim();
      button.setAttribute('aria-busy', mainButton.getAttribute('aria-busy') || 'false');
      sticky.querySelector('[data-sticky-price]').innerHTML = price?.innerHTML || '';
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
    const observer = new MutationObserver(schedule);
    observer.observe(mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
    if (price) observer.observe(price, { childList: true, subtree: true, characterData: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
    sticky.disposeSticky = () => { observer.disconnect(); window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule); document.body.classList.remove('has-sticky-purchase'); };
  };
  const init = () => {
    document.querySelectorAll('[data-review-video-widget]').forEach(initVideos);
    document.querySelectorAll('[data-product-section]').forEach(initSticky);
  };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-review-video-widget]').forEach((widget) => widget.disposeVideos?.());
    event.target.querySelectorAll('[data-sticky-purchase]').forEach((sticky) => sticky.disposeSticky?.());
  });
})();
